/* ASSET: assets/free-shipping-bar.js
   Aggiorna la barra ogni volta che il carrello cambia (aggiunta, modifica quantita', rimozione). */
(() => {
  if (window.__fsbInit) return;
  window.__fsbInit = true;

  let timer;
  const refresh = () => {
    clearTimeout(timer);
    timer = setTimeout(async () => {
      const targets = document.querySelectorAll('[data-fsb]');
      if (!targets.length) return;
      try {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const res = await fetch(`${root}?sections=free-shipping-bar-refresh`, { cache: 'no-store' });
        const data = await res.json();
        const doc = new DOMParser().parseFromString(data['free-shipping-bar-refresh'], 'text/html');
        const fresh = doc.querySelector('[data-fsb]');
        if (fresh) targets.forEach((el) => { el.innerHTML = fresh.innerHTML; });
      } catch (e) {
        console.warn('free-shipping-bar:', e);
      }
    }, 150);
  };

  const isCartUrl = (u) => /\/cart\/(add|change|update|clear)/.test(String(u));

  // Intercetta le chiamate fetch del tema verso le API del carrello
  const origFetch = window.fetch;
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const p = origFetch.apply(this, arguments);
    if (isCartUrl(url)) p.then(refresh).catch(() => {});
    return p;
  };

  // Idem per i temi che usano XMLHttpRequest / jQuery
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartUrl(url)) this.addEventListener('loadend', refresh);
    return origOpen.apply(this, arguments);
  };

  // Aggancio manuale: document.dispatchEvent(new Event('fsb:refresh'))
  document.addEventListener('fsb:refresh', refresh);
})();